const EXTERNAL_DATA_BASE_URL = process.env.EXTERNAL_DATA_BASE_URL;

export const fetchTrains = () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/tid/trains.json?${+ new Date()}`);
export const fetchTrainDetail = (trainUpdatedAt, trainNumber) => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/stop_stations/${trainUpdatedAt}/${trainNumber}.json?${+ new Date()}`);
export const fetchDelay = (date) => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/delays/${date}.json?${+ new Date()}`);
export const fetchTrainStatus = () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/status.json`);
export const fetchCongestion = (trainNumber) => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/congestions/${trainNumber}.json?${+ new Date()}`);

const fetchJSON = async (url) => {
  const fetchParams = {
    mode: 'cors'
  }

  const response = await fetch(url, fetchParams);
  return await response.json();
}
